define('webshopLandingpagesListView',[
  'module',
  'underscore',
  'app',
  'settings',
  'tableView',
  'tableDatetimeFieldView',
  'webshopLandingpagesListFiltersView',
  'webshopLandingpagesListCategoryView',
  'webshopLandingpagesListToolsView',
  'webshopLandingpagesListHeaderToolsView',
  'webshopLandingpagesDetailView',
  'entities/webshop/landingpages'
], function (
  Module,
  _,
  App,
  Settings,
  TableView,
  DatetimeFieldView,
  FiltersView,
  CategoryView,
  ToolsView,
  HeaderToolsView,
  DetailView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'webshop-landingpages-list-view ' + TableView.prototype.className,
    pageSize: 50,
    pageMode: 'pagination',
    filtersViewClass: FiltersView,

    setFields() {
      var fields = [];

      fields.push({
        name: 'Date',
        label: _.i18n('common.date'),
        bind: 'createdAt',
        className: 'date',
        view: DatetimeFieldView
      });

      fields.push({
        name: 'Date',
        label: _.i18n('common.domain'),
        bind: 'domain',
        className: 'domain'
      });

      fields.push({
        name: 'Locale',
        bind: 'locale',
        label: _.i18n('common.locale'),
        className: 'locale'
      });

      fields.push({
        name: 'Code',
        bind: 'code',
        label: _.i18n('common.code'),
        className: 'code'
      });

      fields.push({
        name: 'Template',
        bind: 'template',
        label: _.i18n('common.template'),
        className: 'template'
      });

      fields.push({
        name: 'Category',
        label: _.i18n('common.category'),
        className: 'category',
        view: CategoryView
      });

      fields.push({
        name: 'Tools',
        className: 'tools',
        view: ToolsView,
        headerView: HeaderToolsView
      });

      return fields;
    },

    fetch: function(first, pageSize, sortField, sortDirection, filters) {
      var defer = $.Deferred();

      var params = this.getFiltersParams(filters);
      params.first = first;
      params.pageSize = pageSize;

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('webshop.landingpages.search', params),
        success: _.bind(function (products) {
          var models = [];

          _.each(products, _.bind(function (item) {
            var model = App.request('webshop.landingpage.model', item);
            models.push(model);
          }, this));

          defer.resolve(models);
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function(filters) {
      var defer = $.Deferred();

      var params = this.getFiltersParams(filters);

      if(this.fetchCountRequest)
        this.fetchCountRequest.abort();

      this.fetchCountRequest = $.ajax({
        type: 'GET',
        url: App.request('webshop.landingpages.count', params),
        success: _.bind(function (count) {
          defer.resolve(count);
        }, this)
      });

      return defer.promise();
    },

    getFiltersParams: function(filters) {
      var params = {};

      _.each(filters.attributes, function (value, key) {
        if(key !== 'category') {
          if(value !== '')
            params[key] = value;
        }
      }, this);     

      if(filters.get('category') && filters.get('category').id !== '')
        params.categoryId = filters.get('category').id;

      return params;
    },

    onRowDoubleClick: function(view) {
      DetailView.prototype.open(view.model.getId());    
    },

    onAdd: function() {
      var data = {};

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/landingpages/add'),
        processData: false,
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: _.bind(function (data) {
          this.reload();
          this.footerView.fetch();

          if(data && data.id)
            DetailView.prototype.open(data.id);
        }, this)
      });   
    }
  });
});
